/**
 * EGDE-433: pagination shows at most `max` page circles (per the lobby
 * design). The window slides with the current page — the prev/next arrows
 * "scroll" through the remaining pages — and clamps at both ends so it always
 * contains exactly `max` numbers when there are more than `max` pages.
 *
 * Returns 1-based page numbers.
 */
export function getPaginationWindow(
  current: number,
  total: number,
  max = 5,
): number[] {
  if (total <= max) {
    return Array.from({ length: total }, (_, i) => i + 1)
  }
  const half = Math.floor(max / 2)
  let start = current - half
  if (start < 1) start = 1
  if (start + max - 1 > total) start = total - max + 1
  return Array.from({ length: max }, (_, i) => start + i)
}
